const responsiveConstants = {
  CHANGE_DEVICE_SIZE: 'CHANGE_DEVICE_SIZE',
};

export default responsiveConstants;
